import React from 'react';
import './LandingCTA.css';

const LandingCTA = ({ title, subtitle, onRegisterButtonClicked, compact = false }) => {
    return (
        <section className={`landing-cta-section ${compact ? 'compact' : ''}`}>
            <div className="landing-section">
                <div className="landing-cta-card animate-fade-in-up">
                    <p className="landing-cta-kicker">Passe a l'action</p>
                    <h2 className="landing-cta-title">{title}</h2>
                    <p className="landing-cta-subtitle">{subtitle}</p>
                    <div className="landing-cta-actions">
                        <button className="landing-cta-primary" onClick={onRegisterButtonClicked}>
                            Commencer gratuitement
                        </button>
                        <button
                            className="landing-cta-secondary"
                            onClick={() => window.open('https://calendly.com/estrades-thyms86/30min', '_blank')}
                        >
                            Reserver une demo
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LandingCTA;
